<jni-move-to-freight
  [(display)]="display"
  [brandingConsultantID]="bcledgerFilter?.BrandingConsultantID || ''"
  [freightSelected]="sampleSelected"
  (moveToFreightEvent)="moveToFreightStatus($event)"
  *ngIf="display"></jni-move-to-freight>
<div
  class="d-flex justify-content-between align-items-center globalborder-btm-header pb-3 pt-2 px-3">
  <h2 class="mb-0">Samples</h2>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <p-button
        label="Export Excel"
        variant="outlined"
        icon="pi pi-cloud-upload"
        severity="secondary"
        (click)="exportExcelFile()"
        class="fullwdth secondary-btn" />

      <p-button label="Clear Filters" (click)="clearTable(dt)" />

      <span class="cross-border" (click)="onCloseModalEvent()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>
</div>

<p-table
  #dt
  stripedRows
  [scrollable]="true"
  scrollHeight="calc(100vh - 265px)"
  [size]="'small'"
  [resizableColumns]="true"
  [rows]="20"
  responsiveLayout="scroll"
  [value]="sampleLists"
  [rowHover]="true"
  [rows]="20"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 20, 50, 1000]"
  [paginator]="sampleLists.length >= 20 ? true : false"
  selectionMode="single"
  [(selection)]="sampleSelected"
  styleClass="table-listing p-head-pad p-datatable-customers">
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center">
      <ng-container *ngIf="sampleLists?.length">
        <div
          class="form-group has-float-label me-2 gap-2 d-flex align-items-center">
          <label class="form-label" for="total">Total</label>
          <input
            jniAutoCompleteBlocker
            pInputText
            class="form-control filter me-2 text-end"
            type="text"
            [value]="total | number: '1.2-2'"
            disabled
            *ngIf="total" />
        </div>
        <p-button
          (onClick)="moveToFreight()"
          *ngIf="sampleSelected?.RecID"
          [label]="'Move to freight'" />
      </ng-container>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 6rem" pSortableColumn="Date">
        Date
        <p-sortIcon field="Date"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="Date"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="PurchaseID">
        Purchase order
        <p-sortIcon field="PurchaseID"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="PurchaseID"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="VendorName">
        Vendor name
        <p-sortIcon field="VendorName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="VendorName"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="VendInvoiceID">
        Invoice
        <p-sortIcon field="VendInvoiceID"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="VendInvoiceID"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="Date">
        Original reference
        <p-sortIcon field="Date"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="Date"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="AmountinTransactionCurrency">
        Amount
        <p-sortIcon field="AmountinTransactionCurrency"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="AmountinTransactionCurrency"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="MovedToFreightSalesID">
        Moved to freight sale ID
        <p-sortIcon field="MovedToFreightSalesID"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="MovedToFreightSalesID"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="Description">
        Description
        <p-sortIcon field="Description"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="Description"
          display="menu"></p-columnFilter>
      </th>

      <th pSortableColumn="CreatedBy">
        Created by <p-sortIcon field="CreatedBy"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="CreatedBy"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="VendorName">
        Vendor account
        <p-sortIcon field="VendorName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="VendorName"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="VendorName">
        Transaction ID
        <p-sortIcon field="VendorName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="VendorName"
          display="menu"></p-columnFilter>
      </th>
      <th pSortableColumn="CreatedDateTime">
        Created date and time
        <p-sortIcon field="CreatedDateTime"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="CreatedDateTime"
          display="menu"></p-columnFilter>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-sampleList let-rowIndex="rowIndex">
    <tr
      class="p-selectable-row"
      [pSelectableRow]="sampleList"
      [pSelectableRowIndex]="rowIndex">
      <td>{{ sampleList.Date | date: "MM-dd-yyyy" }}</td>
      <td>{{ sampleList.PurchaseID }}</td>
      <td>{{ sampleList.VendorName }}</td>
      <!-- <td>{{ sampleList.VendInvoiceID }}</td> -->
      <td>
        <a
          *ngIf="sampleList.DocumentURL"
          [href]="sampleList.DocumentURL"
          target="_blank"
          rel="noopener noreferrer">
          {{ sampleList.VendInvoiceID }}
        </a>
        <span *ngIf="!sampleList.DocumentURL">{{
          sampleList.VendInvoiceID
        }}</span>
      </td>
      <td>{{ sampleList.OriginalReference }}</td>
      <td class="align-right">
        {{ sampleList.AmountinTransactionCurrency | number: "1.2-2" }}
      </td>
      <td>{{ sampleList.MovedToFreightSalesID }}</td>
      <td>{{ sampleList.Description }}</td>
      <td>{{ sampleList.CreatedBy }}</td>
      <td></td>
      <td></td>
      <td>
        <span *ngIf="sampleList?.CreatedDateTime | hidedynamicsdate">
          {{ sampleList.CreatedDateTime | date: "MM-dd-yyyy" }}
        </span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="20">No samples found.</td>
    </tr>
  </ng-template>
</p-table>
